// @mui material components
import { Snackbar, Alert, Grid, Card, CircularProgress, Backdrop, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
// import AppConfig from "appConfig";

function Courses() {
  const pageTitle = "Sales Trainings";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [courses, setCourses] = useState([]);

  const tableColumns = [
    { Header: "View", accessor: "action", align: "left" },
    { Header: "Course", accessor: "course", align: "left" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        action: (
          <MDButton
            size="small"
            variant="contained"
            color="info"
            iconOnly
            circular
            onClick={() => {
              navigate(`/courses/${row.reference}`);
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
              visibility
            </Icon>
          </MDButton>
        ),
        course: row.course.title,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/trainings/courses.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRows(result.data.data.courses);
            setCourses(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium">
                          <Icon>school</Icon> Trainings
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" mt={2}>
                          Participate in sales courses, increase your knowledge of the industry,
                          brand and products. By participating in courses, you become a verified
                          sales agent in different industries.
                          <br />
                          <br />
                          <b>NOTE:</b> You can only join a brand&apos;s sales team after taking the
                          required course(s).
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={5}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox ml={1} mr={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDTypography variant="h6" fontWeight="medium">
                              <Icon>local_library</Icon> Courses
                            </MDTypography>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <DataTable
                          table={{ columns: tableColumns, rows: courses }}
                          isSorted
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                          canSearch={false}
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Courses;
